import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet-view_nav-open",
  "use": "icon-sheet-view_nav-open-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-sheet-view_nav-open\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3 2l3.738 4.243L3 10.485\" /><path d=\"M6.524 2l3.738 4.243-3.738 4.242\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol